import React from "react";
import AdminLayout from "./component/AdminLayout";
import ReportedCommentTable from "./ReportedCommentTable";

const ReportedCommentList = () => {
    return (
        <AdminLayout
            pageTitle="신고 댓글 관리"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Reported Comments', active: true }
            ]}
        >
            <div className="main-content">
                <div className="row">
                    <ReportedCommentTable />
                </div>
            </div>
        </AdminLayout>
    );
};

export default ReportedCommentList;
